import React from "react";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

const SIZES = { sm: "h-4 w-4", md: "h-5 w-5", lg: "h-6 w-6" };

export default function LoadingState({ message, size = "md", className }) {
  return (
    <div className={cn("flex items-center justify-center gap-2 py-10 text-muted-foreground", className)}>
      <Loader2 className={cn(SIZES[size], "animate-spin")} aria-label="Loading" />
      {message && <span className="text-sm">{message}</span>}
    </div>
  );
}
